import { tv } from '@otomoro/helpers/mergeClasses'
import { VariantProps } from 'tailwind-variants'

export const styles = tv({
	slots: {
		mobile: 'mt-4 md:hidden',
		desktop: 'hidden md:block md:mt-4 lg:pt-[7rem] lg:mt-[3.5rem] lg:border-t-[0.15rem] border-white',
		rect: 'cursor-pointer transition-fill duration-500 ease-in-out focus:outline-none',
	},
})

export type SchemaVariants = VariantProps<typeof styles>
